/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information.
 *
 * The version of the OpenAPI document: 0.2.2
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PortListPosition } from './PortListPosition';
import {
    PortListPositionFromJSON,
    PortListPositionFromJSONTyped,
    PortListPositionToJSON,
} from './PortListPosition';

/**
 * Port object returned from port list endpoint
 * @export
 * @interface PortList
 */
export interface PortList {
    /**
     * 
     * @type {number}
     * @memberof PortList
     */
    id: number;
    /**
     * 5 alphanumeric characters: 2 for country and 3 for location. Notice that the Locode is not defined for all ports.
     * @type {string}
     * @memberof PortList
     */
    locode: string;
    /**
     * 
     * @type {string}
     * @memberof PortList
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof PortList
     */
    country: string;
    /**
     * 
     * @type {PortListPosition}
     * @memberof PortList
     */
    position: PortListPosition;
}

/**
 * Check if a given object implements the PortList interface.
 */
export function instanceOfPortList(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "locode" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "country" in value;
    isInstance = isInstance && "position" in value;

    return isInstance;
}

export function PortListFromJSON(json: any): PortList {
    return PortListFromJSONTyped(json, false);
}

export function PortListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'locode': json['locode'],
        'name': json['name'],
        'country': json['country'],
        'position': PortListPositionFromJSON(json['position']),
    };
}

export function PortListToJSON(value?: PortList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'locode': value.locode,
        'name': value.name,
        'country': value.country,
        'position': PortListPositionToJSON(value.position),
    };
}

